import { ImperfectiveVerb } from '../../types'

const ебать: ImperfectiveVerb = {
  type: 'imperfective verb',
  infinitive: 'ебать',
  indicativePastSingularMasculine: 'ебал',
  indicativePastSingularFeminine: 'ебала',
  indicativePastSingularNeuter: 'ебало',
  indicativePastPlural: 'ебали',
  indicativePresentSingularFirstPerson: 'ебу',
  indicativePresentSingularSecondPerson: 'ебёшь',
  indicativePresentSingularThirdPerson: 'ебёт',
  indicativePresentPluralFirstPerson: 'ебём',
  indicativePresentPluralSecondPerson: 'ебёте',
  indicativePresentPluralThirdPerson: 'ебут',
  imperativeSingularSecondPerson: 'еби',
  imperativePluralSecondPerson: 'ебите',
}

export default ебать
